import { print } from 'graphql'
import { Customer } from 'shopify-types'

import { storefrontClient } from '@/shopify'
import { GlobalRequestOptions } from '@/shopify/types'

import {
  UpdateDefaultAddressDocument,
  type UpdateDefaultAddressMutation,
} from '../../__generated/storefront'
import { mapGQLCustomerToCustomer } from '../graphql'

export const setDefaultAddress =
  (options: GlobalRequestOptions) =>
  async (token: string, addressId: string): Promise<Customer> => {
    const response = await storefrontClient.request<UpdateDefaultAddressMutation>(
      print(UpdateDefaultAddressDocument),
      {
        variables: {
          addressId: addressId,
          customerAccessToken: token,
          language: options.language,
        },
      },
    )

    const payload = response.data?.customerDefaultAddressUpdate

    if (!payload?.customer) {
      throw new Error('Failed to update default address')
    }

    return mapGQLCustomerToCustomer(payload.customer)
  }
